module.exports = __webpack_public_path__ + "img/code.73eac1de.svg";